module.exports = __webpack_public_path__ + "img/VARIANT_BOX.64599b95.svg";